/* eslint-disable no-restricted-syntax */
/**
 * Safely picks specified properties from an object.
 * This is a secure replacement for lodash.pick that prevents prototype pollution.
 *
 * @param {Object} object - The source object
 * @param {string[]} keys - Array of keys to pick from the object
 * @returns {Object} A new object containing only the specified keys
 */
const pick = (object, keys) => {
  if (!object || typeof object !== "object" || Array.isArray(object)) {
    return {};
  }

  if (!Array.isArray(keys)) {
    return {};
  }

  const result = {};

  for (const key of keys) {
    // Only pick own properties, not inherited ones (prevents prototype pollution)
    if (
      Object.prototype.hasOwnProperty.call(object, key) &&
      key !== "__proto__" &&
      key !== "constructor" &&
      key !== "prototype"
    ) {
      result[key] = object[key];
    }
  }

  return result;
};

export default pick;
